import { Box, Button, Message, ModalDialog, SaveDialog, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

const TEXT = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum eu est sit amet nisl ullamcorper consequat. Mauris urna lacus, pellentesque sit amet magna non, pharetra pellentesque nibh. Praesent viverra id urna sed lacinia. Integer ullamcorper lectus ac arcu ullamcorper venenatis. Curabitur eu elementum elit. Vivamus pellentesque molestie risus non mollis. Morbi lacinia egestas convallis. Duis accumsan erat sit amet purus consectetur, vitae egestas turpis pulvinar. Etiam ac imperdiet purus, id consequat sem. Nunc ultrices at justo quis lacinia. Duis mi lectus, ornare ut euismod sit amet, pretium vel purus. Maecenas ut turpis at sapien mattis semper. Vestibulum quis metus sit amet leo volutpat faucibus quis faucibus orci. Proin odio dui, consectetur nec vestibulum a, fermentum sed arcu. Pellentesque dictum arcu ac sodales hendrerit.";

export default () => {
	const [openLD, setOpenLD] = useState(false);
	const [openRD, setOpenRD] = useState(false);
	const [openLRD, setOpenLRD] = useState(false);
	const [openLeft, setOpenLeft] = useState(false);
	const [openRight, setOpenRight] = useState(false);

	const onClose = (): void => {
		setOpenLD(false);
		setOpenRD(false);
		setOpenLRD(false);
	};

	const onSave = async (): Promise<boolean> => true;

	const onValidate = async (): Promise<boolean> => {
		throw new Error("The Save action generated an error. Hit Cancel to close.");
	};

	const leftDrawerProps = {
		buttonAlwaysVisible: true,
		drawerNode: <Box p={4}>Left Drawer Content</Box>,
		onToggleOpen: setOpenLeft,
		open: openLeft,
		widthOpen: 200,
	};

	const rightDrawerProps = {
		drawerNode: <Box p={4}>Right Drawer Content</Box>,
		onToggleOpen: setOpenRight,
		open: openRight,
		widthOpen: 200,
	};

	return (
		<Box>
			<CssColumnGrid columns={3}>
				<Button design="primary" onClick={() => setOpenLD(true)}>
					Left Drawer Dialog
				</Button>
				<Button design="primary" onClick={() => setOpenLRD(true)}>
					Left &amp; Right Drawers Dialog
				</Button>
				<Button design="primary" onClick={() => setOpenRD(true)}>
					Right Drawer Dialog
				</Button>
			</CssColumnGrid>
			<ModalDialog
				leftDrawerProps={leftDrawerProps}
				onClose={onClose}
				open={openLD}
				showDividers
				title="Left Drawer Dialog"
				width={800}
			>
				{{
					buttons: (
						<Button design="link" onClick={onClose}>Close</Button>
					),
					main: (
						<Text text={TEXT} />
					),
					message: (
						<Message titleText="This is what an error message would look like" variant="error" />
					),
				}}
			</ModalDialog>
			<SaveDialog
				fullHeight
				leftDrawerProps={leftDrawerProps}
				onClose={onClose}
				onSave={onSave}
				onValidate={onValidate}
				open={openLRD}
				rightDrawerProps={rightDrawerProps}
				title="Left & Right Drawer Save Full Height Dialog"
				width={1000}
			>
				{{
					main: (
						<Text text={TEXT} />
					),
				}}
			</SaveDialog>
			<ModalDialog
				onClose={onClose}
				open={openRD}
				rightDrawerProps={rightDrawerProps}
				showDividers
				title="Right Drawer Dialog"
				width={900}
			>
				{{
					buttons: (
						<Button design="link" onClick={onClose}>Close</Button>
					),
					main: (
						<Text text={TEXT} />
					),
					message: (
						<Message titleText="This is what an error message would look like" variant="error" />
					),
				}}
			</ModalDialog>
		</Box>
	);
};